import React from "react";
import Profile from "Pages/Profile";

const Signuptheme = () => {
  return (
    <React.Fragment>
      <Profile />
    </React.Fragment>
  );
};

export default Signuptheme;
